import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

import * as Common from 'common/components';
import Assets from 'components/assets';
import AssetsEdit from 'containers/assets/edit_sections';

import { ASSETS_EDIT_SECTIONS } from 'components/assets/constants';

class AssetsEditSectionSwitch extends PureComponent {
  constructor() {
    super();
    this.sections = Object.values(ASSETS_EDIT_SECTIONS);
    this.state = { section: 'form' };
  }

  componentWillMount = () => {
    const section = this.props.location.hash.split('#').pop();
    if (section && this.sections.indexOf(section) > -1) this.setState({ section });
  };

  renderSection = () => {

    const {
      asset,
      company,
      depreciations,
      subcompany,
      accounts,
      catalogs,
      costCenters,
      employees,
      inpcs,
      isLoading,
      locations,
      projects,
      providers,
      subaccounts,
      sublocations,
      asset_levels,
      history
    } = this.props;

    return (
      {
        [ASSETS_EDIT_SECTIONS.FORM]: (
          <AssetsEdit.FormSection
            asset={asset}
            company={company}
            depreciations={depreciations}
            subcompany={subcompany}
            accounts={accounts}
            catalogs={catalogs}
            costCenters={costCenters}
            employees={employees}
            isLoading={isLoading}
            locations={locations}
            projects={projects}
            providers={providers}
            subaccounts={subaccounts}
            sublocations={sublocations}
            asset_levels={asset_levels}
          />
        ),
        [ASSETS_EDIT_SECTIONS.DEPRECIATION]: (
          <AssetsEdit.DepreciationSection
            asset={asset}
            company={company}
            subcompany={subcompany}
            accounts={accounts}
            catalogs={catalogs}
            costCenters={costCenters}
            employees={employees}
            inpcs={inpcs}
            isLoading={isLoading}
            locations={locations}
            projects={projects}
            providers={providers}
            subaccounts={subaccounts}
            sublocations={sublocations}
            asset_levels={asset_levels}
          />
        ),
        [ASSETS_EDIT_SECTIONS.NOTES]: (
          <AssetsEdit.NotesSection
            asset={asset}
            company={company}
            subcompany={subcompany}
            accounts={accounts}
            catalogs={catalogs}
            costCenters={costCenters}
            employees={employees}
            isLoading={isLoading}
            locations={locations}
            projects={projects}
            providers={providers}
            subaccounts={subaccounts}
            sublocations={sublocations}
            asset_levels={asset_levels}
          />
        ),
        [ASSETS_EDIT_SECTIONS.FILES]: (
          <AssetsEdit.FilesSection
            asset={asset}
            company={company}
            subcompany={subcompany}
            accounts={accounts}
            catalogs={catalogs}
            costCenters={costCenters}
            employees={employees}
            isLoading={isLoading}
            locations={locations}
            projects={projects}
            providers={providers}
            subaccounts={subaccounts}
            sublocations={sublocations}
            asset_levels={asset_levels}
          />
        ),
        [ASSETS_EDIT_SECTIONS.HISTORICS]: (
          <AssetsEdit.HistoricsSection
            asset={asset}
            company={company}
            subcompany={subcompany}
            accounts={accounts}
            catalogs={catalogs}
            costCenters={costCenters}
            employees={employees}
            isLoading={isLoading}
            locations={locations}
            projects={projects}
            providers={providers}
            subaccounts={subaccounts}
            sublocations={sublocations}
            asset_levels={asset_levels}
          />
        ),
        [ASSETS_EDIT_SECTIONS.BILL]: (
          <AssetsEdit.BillSection
            asset={asset}
            company={company}
            subcompany={subcompany}
            accounts={accounts}
            catalogs={catalogs}
            costCenters={costCenters}
            employees={employees}
            isLoading={isLoading}
            locations={locations}
            projects={projects}
            providers={providers}
            subaccounts={subaccounts}
            sublocations={sublocations}
            asset_levels={asset_levels}
            history={history}
          />
        ),
        [ASSETS_EDIT_SECTIONS.CUSTOMSDOCUMENTS]: (
          <AssetsEdit.CustomsDocumentsSection
            asset={asset}
            company={company}
            subcompany={subcompany}
            accounts={accounts}
            catalogs={catalogs}
            costCenters={costCenters}
            employees={employees}
            isLoading={isLoading}
            locations={locations}
            projects={projects}
            providers={providers}
            subaccounts={subaccounts}
            sublocations={sublocations}
            asset_levels={asset_levels}
            history={history}
          />
        ),
      }[this.state.section] || null
    );
  };
  render = () => (
    <div style={{ position: 'relative' }}>
      <Assets.Edit.NavBar
        asset={this.props.asset}
        section={this.state.section}
        handleSectionChange={(section) => this.setState({ section })}
      />
      {this.renderSection()}
      <Common.LoaderOverlay show={this.props.isFetching} />
    </div>
  );
}

export default withRouter(AssetsEditSectionSwitch);



// WEBPACK FOOTER //
// src/containers/assets/AssetsEditSectionSwitch.js